const inboxRoutes = {
  path: "inbox",
  lazy: async () => {
    const mod = await import("views/Admin/Inbox");
    const Inbox = mod.default;
    return { Component: Inbox };
  },
};

export default inboxRoutes;
